import React, { useState } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import { logout } from "../services/auth";
import { notify } from "./Toast";
import { useDispatch } from "react-redux";
import { logout as logoutAction } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";

const LogoutPopup = ({ open, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const response = await logout();
      dispatch(logoutAction());
      notify.success(response.message);

      navigate("/"); //Redirect to Home Page After Logout
    } catch (error) {
      notify.error(error.response?.data?.message);
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableScrollLock
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "80%", sm: 400 },
          bgcolor: "#121212",
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          color: "#fff",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Are you sure you want to logout?
        </Typography>
        <Box sx={{ mt: 3, display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ color: "#fff", borderColor: "#888", mt: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#00ffff",
              color: "#000",
              "&.Mui-disabled": {
                backgroundColor: "#00ffff", // Keep background even when disabled
                color: "#000",
                mt: 2,
              },
            }}
            disabled={isLoading}
            onClick={handleLogout}
          >
            {isLoading ? (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Log Out"
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default LogoutPopup;
